import script from "./AgentCompetencies.vue?vue&type=script&lang=ts&setup=true"
export * from "./AgentCompetencies.vue?vue&type=script&lang=ts&setup=true"

import "./AgentCompetencies.vue?vue&type=style&index=0&id=3f7980bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f7980bc"]])

export default __exports__